import { render, staticRenderFns } from "./TopScrollbar.vue?vue&type=template&id=b074fea0&scoped=true&"
import script from "./TopScrollbar.vue?vue&type=script&lang=js&"
export * from "./TopScrollbar.vue?vue&type=script&lang=js&"
import style0 from "./TopScrollbar.vue?vue&type=style&index=0&id=b074fea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b074fea0",
  null
  
)

export default component.exports